import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/detail-panel-arrow.svg'


const _hoisted_1 = { class: "name" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "tooltip-content" }
const _hoisted_4 = { class: "tooltip-content" }

import { ref } from 'vue'
import { ElButton, ElCollapseItem, ElRow, ElCol, ElTooltip } from 'element-plus';
import DetailCollapse from "../detail-collapse.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'collapse-item',
  props: {
    name: {},
    location: {},
    date: {},
    text: {},
    newFlag: { type: Boolean },
    id: {},
    educationRequired: {}
  },
  setup(__props: any) {

const props = __props;

const locationRef = ref<HTMLElement | null>(null);
const educationRef = ref<HTMLElement | null>(null);
const locationOverflow = ref(false);
const educationOverflow = ref(false);

const checkOverflow = (type: 'location' | 'education') => {
  const el = type === 'location' ? locationRef.value : educationRef.value;
  if (!el) return;
  const overflow = el.scrollHeight > el.clientHeight;
  if (type === 'location') {
    locationOverflow.value = overflow;
  } else {
    educationOverflow.value = overflow;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElCollapseItem), { class: "mtb-20" }, {
    icon: _withCtx(({ isActive }) => [
      _createVNode(_unref(ElButton), { class: "collapse-btn" }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" 详情 ")),
          _createElementVNode("img", {
            class: _normalizeClass(['icon', { up: isActive, }]),
            src: _imports_0
          }, null, 2)
        ]),
        _: 2
      }, 1024)
    ]),
    title: _withCtx(() => [
      _createVNode(_unref(ElRow), {
        class: "title",
        gutter: 10
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElCol), { span: 7 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createTextVNode(_toDisplayString(props.name) + " ", 1),
                (props.newFlag)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "新发布"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(ElCol), { span: 9 }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTooltip), {
                placement: "top-start",
                disabled: !locationOverflow.value
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(props.location), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref_key: "locationRef",
                    ref: locationRef,
                    class: "ellipsis-multi",
                    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (checkOverflow('location')))
                  }, _toDisplayString(props.location), 545)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_unref(ElCol), { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTooltip), {
                placement: "top-start",
                disabled: !educationOverflow.value
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(props.educationRequired || '--'), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref_key: "educationRef",
                    ref: educationRef,
                    class: "ellipsis-multi",
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (checkOverflow('education')))
                  }, _toDisplayString(props.educationRequired || '--'), 545)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(DetailCollapse, {
        text: props.text,
        name: props.name,
        id: props.id
      }, null, 8, ["text", "name", "id"])
    ]),
    _: 1
  }))
}
}

})